/**
 * @Author: zpc
 * @Description: 新增/编辑手工数据弹窗
 * @DateTime: Created in 2024-05-12
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import DatePicker from 'src/types/iview/DatePicker';
import Input from 'src/types/iview/Input';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import { modalFactory } from 'src/util/vueExtend';
import { Toast } from 'src/util/toast';
import DataViewApi from './api/dataViewApi';

export namespace HandMadeDataModalVOI {
    export interface PropsI {
        mn: string;
        time?: string;
        rowData?: any;
        saveSuccess?(): void;
        cancel?(): void;
    }
}

@Component
class HandMadeDataModal extends Vue.Component<HandMadeDataModalVOI.PropsI> {
    @Prop({
        type: String,
    })
    mn!: string;

    @Prop({
        type: String,
    })
    time!: string;

    @Prop()
    rowData!: any;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    @Prop({
        type: Function,
    })
    cancel!: () => void;

    visible: boolean = false;
    loading: boolean = false;
    components: { id: string; name: string }[] = [];

    formData: { time: string; componentKey: string; value: string } = {
        time: '',
        componentKey: '',
        value: '',
    };

    async mounted() {
        if (this.time) {
            this.formData.time = this.time;
        }
        let { code, data } = await DataViewApi.getComponents(this.mn);
        if (code === 0 && data) {
            this.components = data.map(i => ({ id: i.key, name: i.name }));
            if (this.components.length > 0) {
                this.formData.componentKey = this.components[0].id;
            }
        }
    }

    onComponentChange(selectedKey: string) {
        if (this.rowData && selectedKey) {
            const value = this.rowData[selectedKey + '-Rtd'];
            this.formData.value = (value !== undefined && value !== null) ? value : '';
        } else {
            this.formData.value = '';
        }
    }

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!this.formData.time) {
            return Toast.error('请选择手工数据时间');
        }
        if (!this.formData.componentKey) {
            return Toast.error('请选择因子');
        }
        if (!this.formData.value) {
            return Toast.error('请输入手工数据值');
        }
        this.loading = true;
        let { code } = await DataViewApi.saveHandData({
            mn: this.mn,
            time: this.formData.time,
            componentKey: this.formData.componentKey,
            value: this.formData.value
        });
        this.loading = false;
        if (code === 0) {
            Toast.success('保存成功');
            this.saveSuccess && this.saveSuccess();
            this.close();
        }
    }

    async deleteData() {
        this.loading = true;
        let { code } = await DataViewApi.deleteHandData({
            mn: this.mn,
            time: this.formData.time
        });
        this.loading = false;
        if (code === 0) {
            Toast.success('删除成功');
            this.saveSuccess && this.saveSuccess();
            this.close();
        }
    }

    render(h) {
        return (
            <Modal
                title="手工数据"
                width="500"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >
                <i-form ref="formValidate" labelWidth={120} model={this.formData}>
                    <form-item label="手工数据时间：">
                        <DatePicker
                            type="datetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            placeholder="请选择时间"
                            value={this.formData.time}
                            disabled={!!this.time}
                            on-on-change={v => { this.formData.time = v }}
                        />
                    </form-item>
                    <form-item label="因子选择：">
                        <CommonSelect
                            dataSource={this.components}
                            v-model={this.formData.componentKey}
                            on-change={this.onComponentChange.bind(this)}
                            placeholder="请选择因子"
                        />
                    </form-item>
                    <form-item label="手工数据值：">
                        <Input
                            v-model={this.formData.value}
                            placeholder="请输入数据值"
                        />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    {this.time && (
                        <Button type="error" ghost on-click={this.deleteData} loading={this.loading}>
                            删除
                        </Button>
                    )}
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertHandMadeDataModal(
    mn: string,
    time?: string,
    rowData?: any,
): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<HandMadeDataModalVOI.PropsI>(HandMadeDataModal)({
            mn,
            time,
            rowData,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
